module.exports = __webpack_public_path__ + "static/moveon-dc84964fd23e86564d3ff2f138387fe1.png";